import React from 'react';
import '../../../../mobilestyle.css';

const LeaderboardTestItem = ({ data, colorMapping }) => {
  const inGroup     = (data.inGroup || '').trim();
  const guestTextColor = colorMapping?.[inGroup];
  const allRuns     = data.allRuns || [];
  const hasAttempts = allRuns.length > 0;

  return (
    <>
      <div className={`mobile-container${hasAttempts ? ' mobile-container--has-extras' : ''}`}>
        <div className="inner-container">
          <div className="inner-box">
            <div className="number-box">{data.rowNumber}</div>
          </div>
          <div className="badge">
            <div className="badge-text">{data.positionNumber}</div>
          </div>
        </div>
        <div className="m-content">
          <div className="text-content">
            <div className="names">
              <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{(data.driverName || '').trim()}</div>
              <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{(data.coDriverName || '').trim()}</div>
            </div>
            <div className="guest-info">
              <div className="guest-badge" style={{ background: guestTextColor }}>
                <div className="guest-text">{inGroup}</div>
              </div>
              <div className="car-info">{(data.car || '').trim()}</div>
            </div>
          </div>
          <div className="timing">
            <div className="time">{data.resultTime}</div>
          </div>
        </div>
      </div>
      {hasAttempts && (
        <div className="attempt-times">
          {allRuns.map((run) => (
            <div key={run.runNumber} className="attempt-time-badge">
              <span className="attempt-run-number">{run.runNumber}</span>
              <span style={{ fontWeight: run.isBest ? 700 : 400 }}>{run.time || '--'}</span>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

const ROW_FIELDS = [
  'rowNumber', 'positionNumber', 'driverName', 'coDriverName', 'car', 'inGroup', 'resultTime',
];

const runsEqual = (a = [], b = []) =>
  a.length === b.length &&
  a.every((run, i) => run.runNumber === b[i].runNumber && run.time === b[i].time && run.isBest === b[i].isBest);

const areEqual = (prevProps, nextProps) =>
  prevProps.colorMapping === nextProps.colorMapping &&
  ROW_FIELDS.every((f) => prevProps.data[f] === nextProps.data[f]) &&
  runsEqual(prevProps.data.allRuns, nextProps.data.allRuns);

export default React.memo(LeaderboardTestItem, areEqual);
